import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, FormControl, Table } from "react-bootstrap";
import { BiDownvote, BiEdit } from "react-icons/bi";
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import API from "../../services/axiosInstance";
import Permission from "../security/permission";
import { AUTH_CODE } from "../security/authCodes";
import usePreventMultiClick from "../utils/SubmitPrevent";
import { FormLoader, useFormLoader } from "../common_modules/loader";

const RecentInvoice = () => {
    const { id, guid } = useParams();
    console.log(id, guid);

    // const  accGuid = url?.guid;
    // const  accId = url?.id;

    const [recentData, setRecentData] = useState();

    const { handleSubmit, register, watch, setValue, setError, clearErrors, formState: { errors } } = useForm();

    const startDate = watch("startDate");
    const endDate = watch("endDate");

    const dateFn = () => {

        if (!startDate || !endDate) return;
        const start = new Date(startDate);
        const end = new Date(endDate);
        const today = new Date();

        // Normalize (remove time & timezone)
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        // End date greater than today
        if (end.getTime() > today.getTime()) {
            setError("endDate", {
                type: "manual",
                message: "End date cannot be greater than today",
            });
            return;
        }

        // End date before start date
        if (end.getTime() < start.getTime()) {
            setError("endDate", {
                type: "manual",
                message: "End date cannot be before start date",
            });
            return;
        }
        // Clear error if above conditions pass
        clearErrors("endDate");

        const monthsDifference =
            (end.getFullYear() - start.getFullYear()) * 12 +
            (end.getMonth() - start.getMonth());

        if (monthsDifference > 6) {
            setError("endDate", {
                type: "manual",
                message: "Date range cannot exceed 6 months",
            });
        } else {
            clearErrors("endDate");
        }
    }

    const { btnClicked, setBtnClicked } = usePreventMultiClick();
    const { isLoading, startLoading, stopLoading } = useFormLoader();

    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        startLoading();
        try {
            const response = await API.post(
                "/publisher/invoice/download/invoice/report",
                {
                    startDate: data.startDate,
                    endDate: data.endDate,
                    reportType: data.report_type,
                },
                { responseType: "blob" }
            );

            // Format file name
            const start = data.startDate;
            const end = data.endDate;
            const fileName = `invoice-raised-report-${start}_${end}.csv`;

            // Convert blob → download
            const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;

            // file name
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            // cleanup
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setBtnClicked(false);
            stopLoading();
        }
    };

    const recentApi = async () => {
        const response = await API.get('/publisher/invoice/recent/activity');
        console.log(response?.data?.data);
        setRecentData(response?.data?.data);
    }
    // Downlaod payment advice
    const downloadReport = async () => {
        try {
            const response = await API.post('/publisher/invoice/paymentAdvice/download/invoice/report',
                {
                    // id:defaultValues?.id,
                    // accountGuid:defaultValues?.accountGuid,
                    // filePath:defaultValues?.filePath,
                },
                { responseType: "blob" }
            );

            // Extract filename from filePath
            // const fileName = defaultValues?.filePath?.split("/").pop();
            // // Create a download link
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            // console.log(response.data);

            // const a = document.createElement("a");
            // a.href = url;
            // a.download = fileName;
            // document.body.appendChild(a);
            // a.click();

            // a.remove();
            // window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Download Failed:", error);
            alert("Unable to download file!");
        }

    }

    useEffect(() => {
        recentApi();
    }, []);
    useEffect(() => {
        const today = new Date();

        const end = today.toISOString().split("T")[0];

        const start = new Date();
        start.setMonth(start.getMonth() - 1);
        const startVal = start.toISOString().split("T")[0];

        setValue("startDate", startVal);
        setValue("endDate", end);
    }, []);
    useEffect(() => {
        dateFn();
    }, [startDate, endDate]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                <span>View Recent Invoice Activity</span>
                {/* <span>{accId}</span> */}
            </div>
            <Card className="p-3 instreamRows mb-3">
                <h6 className="title mb-2 mt-2">Download Invoice Report</h6>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md={3}>
                            <label>Select Date</label>
                        </Col>
                        <Col md={5}>
                            <div className="d-flex border rounded px-2 dateRange">
                                <Form.Control type="date" className="border-0" {...register('startDate')} />
                                <span className="mx-2">to</span>
                                <Form.Control type="date" className="border-0" {...register('endDate')} />
                            </div>
                            {errors.endDate && (
                                <p className="text-danger small">{errors.endDate.message}</p>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <label>Report Type</label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register('report_type')}>
                                <option value="1">Publisher's Invoice Report</option>
                                <option value="2">Unpaid Overdue Invoice Report</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            {/* Download Report */}
                        </Col>
                        <Permission code={AUTH_CODE.financeInvoice.downloadInvoice}>
                            <Col md={5}>
                                <Button type="submit" variant="success" disabled = {btnClicked} className="rounded-0" style={{ fontSize: "14px" }}><BiDownvote /> Download Report</Button>
                            </Col>
                        </Permission>
                    </Row>
                </Form>
            </Card>
            <Card className="p-3 instreamRows">
                <h6 className="title mb-4 mt-2">Invoice Recent Activity</h6>
                {/* <div className="active-table-wrapper table-responsive"> */}
                <div className="mt-0 table-wrapper mt-3">
                    <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
                        <thead>
                            <tr>
                                <th>Company Name</th>
                                <th>Publisher Name</th>
                                <th>Status</th>
                                <th>Updated Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                recentData?.length > 0 ?
                                    recentData?.map((data, i) => (
                                        <tr key={i}>
                                            <td>{data?.companyName}</td>
                                            <td>{data?.name}</td>
                                            <td>{data?.invoiceStatus}</td>
                                            <td>{data?.lastModified?.split('T')[0]}</td>
                                            {/* <td><button onClick={() => downloadInvoice(data?.invoiceFile)}><BiEdit /> Download invoice</button></td> */}
                                            <td className="activePubAllBtns">
                                                <Link to={`/update-invoice/${data?.id}/${data?.accountId}/${data?.accountGuid}`} state={{
                                                    invoiceId: data?.id,
                                                }}>  <button><BiEdit /> View invoice</button></Link>
                                            </td>
                                        </tr>
                                    )) : <tr><td colSpan={13}>No Data Available</td></tr>
                            }
                        </tbody>
                    </Table>
                </div>
            </Card>
        </FormLoader>
    )
}

export default RecentInvoice;
